import React from 'react';
import {Tooltip, Card, CardActions, CardMedia, Button, Typography} from '@material-ui/core/';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';

import { likePost, deletePost } from '../../../actions/posts';
import useStyles from './styles';

const Post = ({ post, setCurrentId,handleClickOpen}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardMedia className={classes.media} image={post.selectedFile || 'http://via.placeholder.com/180X200'} title={post.title} />
      <Typography className={classes.title} gutterBottom variant="h5" component="h2">{post.title}</Typography>
      <CardActions className={classes.cardActions}>
      <Tooltip data-title="Like" title="">
        <Button size="small" color="primary" onClick={() => dispatch(likePost(post._id))}><ThumbUpAltIcon fontSize="small" /> Like {post.likeCount} </Button>
        </Tooltip>
        <Tooltip data-title="Edit" title="">
        <Button size="small" color="primary" onClick={() => {setCurrentId(post._id);handleClickOpen()}}><Edit fontSize="default"/>Edit</Button>
        </Tooltip>
        <Tooltip data-title="Delete" title="">
  <Button size="small" color="primary" onClick={() => dispatch(deletePost(post._id))}><DeleteIcon fontSize="small" /> Delete</Button>
</Tooltip>



      </CardActions>
    </Card>
  );
};

export default Post;
